export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_06-EN-327118fe2a4db1699d2ea9539c9a93d9.webp";